import * as React from "react";
const SvgFiRrAngleDoubleSmallDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 19a3.9 3.9 0 0 1-2.778-1.151l-3.925-3.875a1 1 0 1 1 1.405-1.423l3.928 3.88c.737.737 2.003.733 2.731.004l3.936-3.884a.999.999 0 1 1 1.404 1.423l-3.93 3.88A3.9 3.9 0 0 1 11.998 19zm.706-5.327 5.999-5.964a1 1 0 0 0 .004-1.414.997.997 0 0 0-1.415-.004l-5.293 5.263-5.296-5.263a1.003 1.003 0 0 0-1.415.004 1 1 0 0 0 .004 1.415l6 5.964a.997.997 0 0 0 1.41 0z"
    />
  </svg>
);
export default SvgFiRrAngleDoubleSmallDown;
